import { create } from "zustand";
import { Option } from "../../components/options/types";
import { ObjectId, UpdateFn, Updater } from "../../types";
import { TOP_TAGS } from "./show-customers/data";

interface State {
  selectedTagOption: Option<ObjectId>;
  searchTerm: string;
}

interface Action {
  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>) => void;
  setSelectedTagOption: UpdateFn<Option<ObjectId>>;
  setSearchTerm: UpdateFn<string>;
}

const useCustomerPageStore = create<State & Action>((set, get) => ({
  selectedTagOption: TOP_TAGS[0],
  searchTerm: "",

  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>): void => {
    if (typeof updater === "function") {
      set((state) => ({ [key]: updater(state[key]) }));
    } else {
      set({ [key]: updater });
    }
  },

  setSelectedTagOption: (updater) => {
    get().setter("selectedTagOption", updater);
  },
  setSearchTerm: (updater) => {
    get().setter("searchTerm", updater);
  },
}));

export default useCustomerPageStore;
